import { LIST_PATIENT, ORIGIN_QR_CODE } from "../actions/action-types";

export const externalPatientsQrCodeReducer = (
  state = {
    originQrCode: false,
    patients: []
  },
  action
) => {
  if (action.type === ORIGIN_QR_CODE) {
    return { ...state, originQrCode: action.originQrCode };
  }
  if (action.type === LIST_PATIENT) {
    return {
      ...state,
      patients: action.patients
    };
  }
  return state;
};
